import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  input,
  OnDestroy,
  OnInit,
  signal,
  viewChild,
} from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
  selector: 'app-content-accordeon',
  imports: [MatExpansionModule],
  templateUrl: './content-accordeon.component.html',
  styleUrl: './content-accordeon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentAccordeonComponent implements OnInit, AfterViewInit, OnDestroy {
  readonly datatitle = input<string>();
  readonly datadisplaytitle = input<string>();
  readonly isopen = input(false, { transform: (v: string | boolean) => !!v }); // legacy
  readonly dataisopen = input(false, { transform: (v: string | boolean) => v === 'true' || v === true });
  readonly datashowpreview = input(true, {
    transform: (v: string | boolean) => v === 'true' || v === true,
  }); // when false never show the preview
  readonly expanded = signal(false);
  readonly hasTruncatedContent = signal(false);

  readonly content = viewChild<ElementRef<HTMLDivElement>>('content');
  private resizeObserver?: ResizeObserver;

  previewHtml = computed(() => this.content()?.nativeElement.innerHTML || '');

  ngOnInit(): void {
    this.expanded.set(this.isopen() || this.dataisopen());
  }

  ngAfterViewInit(): void {
    if (!this.datashowpreview()) {
      return;
    }

    this.updateTruncationState();

    const contentElement = this.content()?.nativeElement;
    if (!contentElement) {
      return;
    }

    this.resizeObserver = new ResizeObserver(() => this.updateTruncationState());
    this.resizeObserver.observe(contentElement);
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }

  private updateTruncationState(): void {
    const contentElement = this.content()?.nativeElement;
    if (!contentElement) {
      this.hasTruncatedContent.set(false);
      return;
    }

    const previewHeight = this.getPreviewHeight(contentElement);
    const hasOverflow = contentElement.scrollHeight > previewHeight + 1;
    this.hasTruncatedContent.set(hasOverflow);
    if (!this.hasTruncatedContent()) {
      this.expanded.set(true);
    }
  }

  private getPreviewHeight(contentElement: HTMLDivElement): number {
    const previewHeightValue = getComputedStyle(contentElement).getPropertyValue('--preview-height').trim();
    const parsed = Number.parseFloat(previewHeightValue);
    return Number.isFinite(parsed) ? parsed : 130;
  }
}
